import React, { Component } from "react";
import { Route } from "react-router-dom";
import { ACCOUNT_APP_URL } from "../../config/environment";
import { getCookie, hasP } from "../../utils/helpers";

class ProtectedRoute extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAuthenticated: false,
      hasPermission: false,
    };
  }

  componentWillMount() {
    const user = getCookie("user") ? JSON.parse(getCookie("user")) : {};
    this.setState({
      isAuthenticated: !!getCookie("user_token"),
      hasPermission: hasP("ACCESS_PEOPLE", user.role),
    });
  }

  render() {
    const {
      siteLanguage,
      screen,
      signOutUser,
      component: Component,
      ...props
    } = this.props;
    const { isAuthenticated, hasPermission } = this.state;

    return (
      <Route
        {...props}
        render={(props) =>
          isAuthenticated && hasPermission ? (
            <Component {...props} screen={screen} />
          ) : (
            <div>
              {isAuthenticated
                ? window.location.assign(ACCOUNT_APP_URL)
                : signOutUser()}
            </div>
          )
        }
      />
    );
  }
}

export default ProtectedRoute;
